import styled from '@emotion/styled'
import { NavLink } from 'react-router-dom'
import { colors } from '../colors'

export const SidebarItemContainer = styled.div<{
  isActive: boolean
  $collapsed: boolean
}>`
  display: flex;
  align-items: center;
  gap: ${({ $collapsed }) => ($collapsed ? '0' : '12px')};
  padding: ${({ $collapsed }) => ($collapsed ? '10px 8px' : '8px 12px')};
  margin: ${({ $collapsed }) => ($collapsed ? '2px 2px' : '2px 8px')};
  cursor: pointer;
  border-radius: 6px;
  background-color: ${({ isActive }) =>
    isActive ? colors.gray300 : 'transparent'};
  color: ${({ isActive }) => (isActive ? colors.gray700 : colors.gray700)};
  justify-content: ${({ $collapsed }) =>
    $collapsed ? 'center' : 'flex-start'};

  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? colors.gray300 : colors.gray200};
  }
`

export const SidebarItemIcon = styled.div<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const SidebarItemText = styled.span<{
  isActive: boolean
  $collapsed: boolean
}>`
  font-size: 14px;
  color: ${colors.gray700};
  white-space: nowrap;
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'inline')};
`

export const SidebarNavLink = styled(NavLink)`
  text-decoration: none;
  display: block;
  color: inherit;
`
